import { render } from "./sendMailModal.vue?vue&type=template&id=0beb1e92&scoped=true&ts=true"
import script from "./sendMailModal.vue?vue&type=script&lang=ts"
export * from "./sendMailModal.vue?vue&type=script&lang=ts"

import "./sendMailModal.vue?vue&type=style&index=0&id=0beb1e92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0beb1e92"]])

export default __exports__